import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getStorage } from "../auth/utils";

const AuthContext = createContext();
const { Provider } = AuthContext;

const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const token = getStorage().getItem("token");
  const user = getStorage().getItem("user");

  let club = getStorage().getItem("club");
  try {
    club =
      club && club !== "undefined" && club !== "null"
        ? JSON.parse(club)
        : undefined;
  } catch {
    club = undefined;
  }

  const [authState, setAuthState] = useState({
    token,
    user: user ? JSON.parse(user) : {},
    club: club || {},
  });

  const setAuthInfo = ({ token, user, club }) => {
    if (token) getStorage().setItem("token", token);
    if (user) getStorage().setItem("user", JSON.stringify(user));

    if (club !== undefined) {
      getStorage().setItem("club", JSON.stringify(club));
    } else {
      getStorage().removeItem("club");
    }

    setAuthState({ token, user, club });
  };

  const logout = () => {
    getStorage().removeItem("token");
    getStorage().removeItem("user");
    getStorage().removeItem("club");
    setAuthState({});
    navigate("/login");
  };

  const isAuthenticated = () => {
    const { token, user } = authState;
    if (!token || !user) return false;

    const hasValidRole = user?.isAdmin;

    return hasValidRole;
  };

  const isSuperAdmin = () => {
    return authState.user?.isAdmin;
  };

  const _user = authState.user;
  const _club = authState.club;

  return (
    <Provider
      value={{
        authState: { ...authState, user: _user, club: _club },
        setAuthState: (authInfo) => setAuthInfo(authInfo),
        logout,
        isAuthenticated,
        isSuperAdmin,
      }}
    >
      {children}
    </Provider>
  );
};

export const useAuthContext = () => {
  return useContext(AuthContext);
};

export { AuthContext, AuthProvider };
